import http from '@/utils/request';

/**
 * 订单变更列表
 * 订单变更审核列表包括：取消订单、修改订单
*/
export const getOrderList = (data = {}) => {
  const url = '/receipt/order/bopList';
  return http.post({
    url,
    data,
  });
};

// 订单变更详情
export const getOrderDetail = (data = {}) => {
  const url = '/receipt/order/detail';
  return http.post({
    url,
    data,
  });
};

// 订单变更审核
export const approvalOrder = (data = {}) => {
  const url = '/order/inner/order/order_update/approval';
  return http.post({
    url,
    data,
  });
};


// 收款-取消/修改订单审核导出
export const EXPORT_ORDER_UPDATE = '/receipt/export/orderUpdate';
